import {
  Button,
  Select,
  SelectItem,
  Divider,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Switch,
} from "@heroui/react";
import { t } from "@lingui/core/macro";
import { Search, Settings2 } from "lucide-react";
import { LimeInput } from "@/Components/NextBase/LimeInput";
import { useSearchParams } from "react-router";

type SortOption = "durationAsc" | "durationDesc" | "priceAsc" | "priceDesc";

export const VariationsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchQueryRaw = searchParams.get("q");
  const sortByRaw = searchParams.get("sortBy");
  const showInactiveRaw = searchParams.get("showInactive");

  const searchQuery = searchQueryRaw ?? "";
  const sortBy =
    (sortByRaw as "durationAsc" | "durationDesc" | "priceAsc" | "priceDesc") ||
    "durationAsc";
  const showInactive = showInactiveRaw === "true";

  const sortOptions = [
    { key: "durationAsc", label: t`Trajanju (naraščajoče)` },
    { key: "durationDesc", label: t`Trajanju (padajoče)` },
    { key: "priceAsc", label: t`Ceni (naraščajoče)` },
    { key: "priceDesc", label: t`Ceni (padajoče)` },
  ];

  return (
    <div className="flex items-end justify-start gap-3">
      <LimeInput
        isClearable
        variant="bordered"
        className="w-full sm:max-w-80"
        placeholder={t`Iskanje po trajanju ali ceni...`}
        startContent={<Search />}
        value={searchQuery}
        onClear={() => {
          setSearchParams((prev) => {
            prev.delete("q");
            return prev;
          });
        }}
        onValueChange={(value) => {
          setSearchParams((prev) => {
            if (value === "") {
              prev.delete("q");
            } else {
              prev.set("q", value);
            }
            return prev;
          });
        }}
      />
      <Popover>
        <PopoverTrigger>
          <Button
            isIconOnly
            variant="flat"
            startContent={<Settings2 className="text-xl" />}
          ></Button>
        </PopoverTrigger>
        <PopoverContent
          aria-label={t`Nastavitve prikaza`}
          className="flex items-start justify-start gap-4 p-4"
        >
          <div className="flex w-full flex-col gap-2 py-1">
            <span className="font-semibold">{t`Razvrsti po`}</span>
            <Select
              selectedKeys={new Set([sortBy])}
              onSelectionChange={(keys) => {
                const key = Array.from(keys)[0] as SortOption;
                if (key) {
                  setSearchParams((prev) => {
                    prev.set("sortBy", key);
                    return prev;
                  });
                }
              }}
              className="w-full"
            >
              {sortOptions.map((option) => (
                <SelectItem key={option.key}>{option.label}</SelectItem>
              ))}
            </Select>
          </div>

          <Divider className="my-1" />

          <span className="font-semibold">{t`Filtri`}</span>
          <Switch
            key="showInactive"
            title={t`Prikaži neaktivne variacije`}
            startContent={showInactive ? "✓" : ""}
            isSelected={showInactive}
            onValueChange={(value) => {
              setSearchParams((prev) => {
                if (value) {
                  prev.set("showInactive", "true");
                } else {
                  prev.delete("showInactive");
                }
                return prev;
              });
            }}
            size="sm"
          >
            {showInactive
              ? t`Prikazane so vse variacije`
              : t`Prikazane so samo aktivne variacije`}
          </Switch>
        </PopoverContent>
      </Popover>
    </div>
  );
};
